import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { deleteFile, getData, getFile, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible, setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import saveAs from "file-saver";


interface RecursoState {
    status: string;
    error: string;
    recursoList: any[],
    recurso: {
        idSesion: number | null;
        idGrupoSesion: number | null;
        idRecurso: number | null;
        titulo: string | null;
        descripcion: string | null;
        urlRecurso: string | null;
        fileData: string | null;
        fileUrl: string | null;
    }

}

const initialState: RecursoState = {
    status: 'idle',
    error: '',
    recursoList: [],
    recurso: {
        idSesion: null,
        idGrupoSesion: null,
        idRecurso: null,
        titulo: null,
        descripcion: null,
        urlRecurso: null,
        fileData: null,
        fileUrl: null
    }
}

export const fetchRecurso = createAsyncThunk('fetchRecurso', async ({ idSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 82;
    const { result, message, data } = await getData({ idsp, idSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchFacilitadorRecurso = createAsyncThunk('fetchFacilitadorRecurso', async ({ idGrupoSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 123;
    const { result, message, data } = await getData({ idsp, idGrupoSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const createModifyRecurso = createAsyncThunk('createModifyRecurso', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const recursoNew = selectRecurso(state);
    const recursoAttributes = { ...recursoNew };
    const idsp = recursoAttributes.idRecurso ? 84 : recursoAttributes.idGrupoSesion ? 122 : 83;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...recursoAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (!recursoAttributes.idRecurso && recursoAttributes.fileData !== null && recursoAttributes.fileData !== '') {
            const { result: resultFile } = await postFile({ idsp: 81, id: data, dir: "sesion", fileData: recursoAttributes.fileData, fileName: data }, getState, dispatch);
            if (!resultFile) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "RECURSO NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        recursoAttributes.idGrupoSesion ? dispatch(setVisible(false)) : dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    recursoAttributes.idGrupoSesion ? dispatch(fetchFacilitadorRecurso({ idGrupoSesion: recursoAttributes.idGrupoSesion })) : dispatch(fetchRecurso({ idSesion: recursoAttributes.idSesion }));
    return rejectWithValue(message);
});

export const downloadRecurso = createAsyncThunk('downloadRecurso', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const recursoNew = selectRecurso(state);
    const recursoAttributes = { ...recursoNew };
    let alert: AlertInterface;
    if (recursoAttributes.fileUrl) {
        const fileExtension = recursoAttributes.fileUrl.substring(recursoAttributes.fileUrl.lastIndexOf('.'));
        const fileName = `${recursoAttributes.titulo}${fileExtension}`;
        const response = await getFile({ fileUrl: recursoAttributes.fileUrl, fileName: fileName });

        if (response && response.blob) {
            saveAs(response.blob, fileName);
            alert = { title: 'CORRECTO..!', message: "RECURSO DESCARGADO CORRECTAMENTE", data: [], type: 'LimeGreen', time: Date.now() };
        } else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: "RECURSO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
        }
    } else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: "RECURSO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
});

export const deleteRecurso = createAsyncThunk('deleteRecurso', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const recursoNew = selectRecurso(state);
    const recursoAttributes = { ...recursoNew };
    const idsp = 85;
    let alert: AlertInterface;
    const { result, message, data } = await getData({ idsp, idRecurso: recursoAttributes.idRecurso }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (recursoAttributes.fileUrl !== null && recursoAttributes.fileUrl !== '') {
            await deleteFile([{ fileUrl: recursoAttributes.fileUrl }], getState, dispatch);
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    recursoAttributes.idGrupoSesion ? dispatch(fetchFacilitadorRecurso({ idGrupoSesion: recursoAttributes.idGrupoSesion })) : dispatch(fetchRecurso({ idSesion: recursoAttributes.idSesion }));
    return rejectWithValue(message);
});

export const recursoSlice = createSlice({
    name: 'recurso',
    initialState,
    reducers: {
        setRecursoList: (state, action) => {
            state.recursoList = action.payload;
        },
        setRecurso: (state, action) => {
            state.recurso = !action.payload ? initialState.recurso : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchRecurso.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchRecurso.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.recursoList = data ? data : [];

            })
            .addCase(fetchRecurso.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchFacilitadorRecurso.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFacilitadorRecurso.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.recursoList = data ? data : [];

            })
            .addCase(fetchFacilitadorRecurso.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectRecursoList = (state: RootState) => state.recurso.recursoList;
export const selectRecurso = (state: RootState) => state.recurso.recurso;

export const { setRecursoList, setRecurso } = recursoSlice.actions;

export default recursoSlice.reducer;